import React from 'react'
import Text from '../formatting/Text'

export default function SplitValues (props) {

  const {
    children,
    secondary = null,
    className = '',
    splitter = '|',
  } = props

  return (
    <div className={'flex space-x-2 justify-end ' + className}>
      <Text weight='medium' block className='min-w-4xs text-right'>
        {children}
      </Text>
      <Text>{splitter}</Text>
      <Text color='gray' block>
        {secondary}
      </Text>
    </div>
  )
}
